import React from "react"
import { AppBulkEditAction } from "@components"

import { useUserSettingsProvider, useUserSettingsProviderValidator } from "../../../@hooks"


export default function UserSettingProviderDrawerSubmit() {
	const { isLoading, handleSubmitProviderFormData } = useUserSettingsProvider()
	const { isValid } = useUserSettingsProviderValidator()

	return <AppBulkEditAction
		loading={isLoading}
		disabled={!isValid}
		onClick={handleSubmitProviderFormData}
	>
		Save
	</AppBulkEditAction>
}